import { Component, ElementRef, Inject, Input, OnInit, Optional, Renderer2, SimpleChanges } from '@angular/core';
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FndBaseFormElementComponent } from 'app/shared/reusable-components/fnd-base-form-element.component';
import { Utils } from 'app/shared/utility/utils';
import { TitleCasePipe } from '@angular/common';

declare var window: any;
declare var document: any;

@Component({
	selector: 'app-select-atm',
	templateUrl: './select-atm.component.html',
	providers: [TitleCasePipe, { provide: NG_VALUE_ACCESSOR, useExisting: SelectAtmComponent, multi: true }],
	styleUrls: ['./select-atm.component.scss']
})
export class SelectAtmComponent extends FndBaseFormElementComponent implements OnInit {

	public static readonly LAYOUT_DEFAULT = "default";
	public static readonly LAYOUT_SIFF = "siff";

	selectedIndex: any;
	cittaSelezionata = false;
	regioneSelezionata = false;

	public regioni = [
		"ABRUZZO",
		"BASILICATA",
		"CALABRIA",
		"CAMPANIA",
		"EMILIA ROMAGNA",
		"FRIULI VENEZIA GIULIA",
		"LAZIO",
		"LIGURIA",
		"LOMBARDIA",
		"MARCHE",
		"MOLISE",
		"PIEMONTE",
		"PUGLIA",
		"SARDEGNA",
		"SICILIA",
		"TOSCANA",
		"TRENTINO ALTO ADIGE",
		"UMBRIA",
		"VALLE D'AOSTA",
		"VENETO"
	];

	selectLabel = "";
	_options = [];
	selectedValue = "";
	_province = [];
	selector = "";
	_uiInit = false;
	open = false;

	@Input('options')
	set options(value: Array<any>) {
		this._options = value;
		if(this.layout == SelectAtmComponent.LAYOUT_DEFAULT){
			this.refreshDefaultSelect();
		}
	}

	get options(): Array<any> {
		return this._options;
	}

	isMobileIOS: boolean;

	@Input() layout: string = SelectAtmComponent.LAYOUT_DEFAULT;

	constructor(
		@Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
		@Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
		private renderer: Renderer2,
		private titleCasePipe: TitleCasePipe,
		private ref: ElementRef
	) {
		super(validators, asyncValidators);

		// default layout
		if(this.layout == SelectAtmComponent.LAYOUT_DEFAULT) {
			this.selector = "fndselect"+ UniqueId.getInstance().getId();
			if(this.selectLabel == null) {
				this.selectLabel = "";
			}
		}
		// siff layout
		if(this.layout == SelectAtmComponent.LAYOUT_SIFF) {
			this.computeSelectLabel();
		}
	}

	ngOnInit() {}

	getWidthLabel() {
		let el = this.ref.nativeElement.querySelector(".mdl-js-textfield");
		return el;
	}

	ngOnChanges(changes: SimpleChanges) {
		if(changes.options && !changes.options.isFirstChange()) {
			// when options change reset label
			this.selectLabel = "";
			this.ngAfterContentInit();
		}
		if(changes.model) {
			this.ngAfterContentInit();
		}
		if(changes.value) {
			this.computeSelectLabel();
		}
	}

	ngAfterContentInit() {
		if(this.model !== null) {
			this.writeValue(this.model);
		}

		this.computeSelectLabel();
	}

	ngAfterViewInit() {
		// default layout
		if(this.layout == SelectAtmComponent.LAYOUT_DEFAULT) {
			if(!this._uiInit) {
				this._uiInit = true;
				//this.refreshDefaultSelect();
				let ne = this.ref.nativeElement;
				//let el = this.ref.nativeElement.querySelector(".mdl-js-textfield");
				//var elWidth = el.value.length;

				this.renderer.listen('document', 'click', (event) => {
					try {
						ne.querySelector(".mdl-js-menu").MaterialMenu.hide();
						super.onBlur(event);

						const parentAbove = document.querySelector('.fd-card-above');
						if (parentAbove) {
							this.renderer.removeClass(parentAbove, 'cp-open');
						}
						document.querySelector('.' + this.selector).classList.remove('is-open');
					}
					catch (e) {
					}
				});
			}
		}

		// siff layout
		if(this.layout == SelectAtmComponent.LAYOUT_SIFF) {
			if(!this._uiInit) {
				this._uiInit = true;
				this.renderer.listen('document', 'click', (event) => {
					this.open = false;
				});
			}
		}
	}

	onBlur(event: any) {
		super.onBlur(event);
	}

	/**
	 * Value change event for default layout
	 */
	private onDefaultValueChange(value: string, index: number) {
		super.onBlur(<any>{});

		this.selectedIndex = index;
		this.selectedValue = value.toLocaleUpperCase();

		/* var labelWidth = this.ref.nativeElement.querySelector('input.mdl-textfield__input').value
		var widthContainer = (labelWidth * 10 + 1) + 'px';
		var container = this.ref.nativeElement.querySelector('.container-select');
		container.offsetWidth = widthContainer; */

		/* var val = this.ref.nativeElement.querySelector('input.mdl-textfield__input').value;
		val = val.toLowerCase();
		val = val.charAt(0).toUpperCase() + val.slice(1);
	
		this.ref.nativeElement.querySelector('input.mdl-textfield__input').value = val; */

		let id = this.id;
		this.options.forEach(element => {
			if(element.label == value) {
				this.selectLabel = element.label;
				this.value = element.value;
				this.valueChange.emit({ id: id, value: element.value, label: element.label });
			}
		});
	}

	/**
	 * Toggle event for default layout
	 */
	onDefaultToggle(event: any) {
		if(!this.disabled) {
			const menu = this.ref.nativeElement.querySelector('.mdl-js-menu');
			menu.MaterialMenu.show();

			this.isMobileIOS = (/iphone|ipad/.test(navigator.platform.toLowerCase()) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1)) && !window.MSStream;

			setTimeout(() => {
				super.onFocus();
			}, 0);

			if (this.isMobileIOS) {
				menu.addEventListener('transitionend', () => {
					// Recalculate regions height and override previous mdl height
					if(this.options && this.name === 'atmRegion') {
						// document.querySelector('.mdl-menu__container.is-upgraded.is-visible').style.height = (this.options.length * 37) +"px";
						// document.querySelector('.mdl-menu__container.is-upgraded.is-visible').style.transition = this.options.length * 37 + " visibility 0s ease 0s, opacity .3s ease 0s, transform .3s ease 0s !important";
						// document.querySelector('.mdl-menu__outline.mdl-menu--bottom-left').style.height = (this.options.length * 37) +"px";
						// document.querySelector('.mdl-menu__outline.mdl-menu--bottom-left').style.transition = this.options.length * 37 + " visibility 0s ease 0s, opacity .3s ease 0s, transform .3s ease 0s !important";
					}
					this.renderList();
				}, true);
			} else {
				this.renderList();
			}
		}
	}

	renderList() {
		const parentAbove = document.querySelector('.fd-card-above');

		const options = this.options;
		setTimeout(() => {
			if(document.querySelector('.'+ this.selector) && document.querySelector('.'+ this.selector).classList.contains('is-upgraded')) {
				if(parentAbove) {
					this.renderer.addClass(parentAbove, 'cp-open');
				}
				document.querySelector('.' + this.selector).classList.add('is-open');
			}

			if(!this.isMobileIOS) {
				// Recalculate regions height and override previous mdl height
				setTimeout(() => {
					if (options && this.name === 'atmRegion') {
						let atmRegionHeight = (options.length * 37) +"px";
						document.querySelector('.mdl-menu__container.is-upgraded.is-visible').style.height = atmRegionHeight;
						document.querySelector('.mdl-menu__outline.mdl-menu--bottom-left').style.height = atmRegionHeight;
					}
				}, 0);
			}

			// Recalculate province height and override previous mdl height
			let timeProvince = 0;
			if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
				timeProvince = 10;
			}
			setTimeout(() => {
				if(options && this.name === 'atmProvince') {
					let atmProvinceHeight = ((options.length * 37) + 10) +"px";
					document.querySelector('.mdl-menu__container.is-upgraded.is-visible').style.height = atmProvinceHeight;
					document.querySelector('.mdl-menu__outline.mdl-menu--bottom-left').style.height = atmProvinceHeight;
				}
			}, timeProvince);

		}, 0);
	}

	onDefaultFocusOut(event: any) {
		super.onBlur(event);
	}

	refreshDefaultSelect() {
		let _selector = this.selector;
		this.selectedIndex = "";
		this.selectedValue = "";

		setTimeout(function () {
			try {
				window.getmdlSelect.init("." + _selector);
			}
			catch (e) {
			}
		}, 100);
	}

	/**
	 * Open event for siff layout
	 */
	onSiffOpen(event: any) {
		this.open = true;
		event.stopPropagation();
	}

	onSiffValueChange(item) {
		this.model = item.value;
		this.value = item.value;
		this.computeSelectLabel();
		this.valueChange.emit({ id: this.id, value: item.value });
	}

	computeSelectLabel() {
		if(this.layout == SelectAtmComponent.LAYOUT_DEFAULT) {
			this.options.forEach(element => {
				if(element.value == this.value) {
					this.selectLabel = element.label;
					this.selectedValue = this.regioni.indexOf(this.selectLabel)!== -1 ? this.titleCasePipe.transform(this.selectLabel) : this.selectLabel;
					this.selectLabel = this.selectLabel.toLocaleLowerCase();
					this.selectLabel = Utils.formatOptionValue(this.selectLabel);
				}
				//this.selectLabel.charAt(0).toUpperCase() + this.selectLabel.slice(1);
				//let el = this.ref.nativeElement.querySelector(".mdl-js-textfield");
				//var elWidth = el.value.length;
			});
			if(this.selectLabel == null) {
				this.selectLabel = "";
			}
		}
		else if(this.layout == SelectAtmComponent.LAYOUT_SIFF) {
			this.open = false;
			if(this.options !==  null) {
				try {
					this.options.forEach(group => {
						group.values.forEach(element => {
							if(element.value == this.value) {
								this.selectLabel = element.label;
								this.selectLabel = this.selectLabel.toLocaleLowerCase();
								this.selectLabel = this.selectLabel.charAt(0).toUpperCase() + this.selectLabel.slice(1);
								this.value = element.value;
							}
						});
					});
				}
				catch (e) {}
			}
		}
	}
}

class UniqueId {

	private static _instance: UniqueId = new UniqueId();
	private _id = 0;

	constructor() {
		UniqueId._instance = this;
	}

	public static getInstance(): UniqueId {
		return UniqueId._instance;
	}

	public getId(): number {
		this._id++;
		return this._id;
	}

}